module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Home":"Home","Changelog":"Changelog","Examples":"Examples","Language":"Language"},"ru":{"Home":"В начало","Changelog":"Список изменений","Examples":"Примеры","Language":"Язык"}}')
  delete Component.options._Ctor
}
